import React from 'react';
import { ArrowLeft } from 'lucide-react';

// Page header: back button + integration icon + dynamic title
export function ConfigHeader({ icon, title, onBack }) {
    return (
        <div className="flex items-center gap-4 mb-8">
            <button type="button" onClick={onBack} className="p-2 hover:bg-gray-100 rounded-lg text-gray-500 transition-colors" aria-label="Go back">
                <ArrowLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-3">
                <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm">{icon}</div>
                <h1 className="text-xl font-bold text-gray-900">{title}</h1>
            </div>
        </div>
    );
}
